import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'

import { Button, Grid, Step, StepLabel, Stepper, Tooltip } from '@mui/material'
import { 
  useGET_plopQuestionCategoriesQuery,
  useGET_plopReportByIdQuery,
  usePOST_plopReportMutation,
  usePATCH_plopReportMutation,
  useDELETE_plopReportMutation
} from 'redux/api/plopApi'

import { Form, Formik } from 'formik'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import formModel, { initialValues } from 'utils/formModels/plopReportModel'
import { crudColorMap, crudIconMap, plopImportanceSelectData, plopPointsChoices}  from 'utils/helpers'
import { ActionType } from 'types'
import { useGET_studentByProfileIdQuery } from 'redux/api/studentsApi'
import SelectField from 'components/atoms/fields/SelectField'
import useCrudData from 'utils/customHooks/useCrudData'
import { useNavigate } from 'react-router-dom'
import _ from 'lodash'
import RadioField from 'components/atoms/fields/RadioField'



interface IProps {
  action: ActionType
  id?: string
  studentId?: any
  viewOnly?: boolean
  isStudentProfile?: boolean
  onSuccess?: any
}


const PlopReportForm: FC<IProps> = ({ 
  action, 
  id = null, 
  studentId = null, 
  viewOnly = false, 
  isStudentProfile = false, 
  onSuccess = () => {} 
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const backToSlug =  isStudentProfile ? `/rti-students/${studentId}#plop ` : `/plop-reports`

  const { data: currentStudent } = useGET_studentByProfileIdQuery(studentId, {skip: !studentId})
  const { data: plopQuestionCategories } = useGET_plopQuestionCategoriesQuery()

  
  const { isLoading, entity, handleSubmit } = useCrudData({
    backToSlug,
    entityName: `${t('rti.plop')}`,
    entityId: id,
    onSuccess: () => { onSuccess() },
    getEntityQuery: useGET_plopReportByIdQuery,
    createEntityMutation: usePOST_plopReportMutation,
    editEntityMutation: usePATCH_plopReportMutation,
    deleteEntityMutation: useDELETE_plopReportMutation,
  })

  const {      
    answers, 
  } = formModel()


  const serverValues = entity?.id ? entity : {
    answers: []
  }

  const selectedStudentId = entity?.id 
  ? serverValues.student.id 
  : currentStudent 
    ? currentStudent.student_profile_id
    : null

  const selectedStudent = entity?.id 
    ? serverValues.student.title 
    : currentStudent 
      ? currentStudent.first_name+' '+currentStudent.last_name+' ['+currentStudent.academic_id+']'
      : null


  /*
  const entity_answers = _.chain(serverValues.answers.map(a => { return {
    'name': a.question_id,
    'value': a.question_id,
    'points': a.points,
    'importance': a.importance
  }}))
    .keyBy('name')
    .mapValues('value')
    .value();
  */

  const entity_answers = {}

  if(plopQuestionCategories && currentStudent)
    for(let c of plopQuestionCategories.list){
      for(let q of c.questions.filter(q => q.grade_level == currentStudent.grade_level)){
        entity_answers[q.id]={
          'name': q.id,
          'value': q.id,
          'points': 0,
          'importance': {
            id: q.default_importance, 
            title: q.default_importance+' - '+t(`plop-importance-options.${q.default_importance}`)
          }
        }
      }
    }


  const options = plopPointsChoices()

  const formValues = {
    ...initialValues,
    ...serverValues,
    answers: entity_answers,
  }


  const [activeStep, setActiveStep] = useState(0)

  
  return ( <>

    { selectedStudentId && plopQuestionCategories &&  (entity?.id || !id) &&
        <Formik
          enableReinitialize
          initialValues={formValues}
          onSubmit={(values) => {

           
            const data_student_id = currentStudent ? currentStudent.student_profile_id : (values?.student?.id ?? '')

            const data = {
              student_id: data_student_id,
              answers: Object.entries(values.answers).map(([k, a]: [any, any]) => {
                return {
                  question_id: k,
                  importance: a.importance?.id ?? 1,
                  points: a.points
                }
              }),
              evaluations: []
            
            }
     
            handleSubmit(action, entity?.id, data)
          }}
        >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form>
            <Grid container spacing={4} mt={1}>
              <Grid item xs={12} lg={12}>
                  {(entity?.id || !id) && plopQuestionCategories && currentStudent &&
                  

                    <div style={{ display: 'flex', gap: '20px', width: '100%'}}>
                        <div style={{ width: '180px' }} className='plop-stepper'>
                          <Stepper activeStep={activeStep} orientation='vertical' sx={{ height: '100%' }}>
                            {plopQuestionCategories.list.map((category, index) => (
                              <Step key={category.title} sx={{ height: '5rem', textAlign: 'center' }}>
                                <StepLabel>{category.title}</StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </div>  
                        <div style={{ width: `calc(100% - 180px)` }}>

                          {plopQuestionCategories.list.map((category, index: number) => ( 
                            <div className='simple-table-wrapper'  key={category.id} 
                                style={{ display: activeStep===index ? 'block' : 'none'}}>
                              <table className='checklist-table'>
                                <tbody>
                                  <tr>
                                    <th style={{width:'35%'}}>{index+1}. {category.title}</th>
                                    <th style={{textAlign:'center',width:'25%'}}>{t('common.weight')}</th>
                                    <th style={{textAlign:'center'}}>{t('common.observed-skills')}</th>
                                  </tr>

                                  <tr className='checklist-table-subheading'>
                                    <th></th>
                                    <th></th>
                                    <th>
                                      <div style={{ display: 'flex', width: '100%' }}>
                                        {options
                                          .filter(o => o.value != "0")
                                          .map(o => 
                                            <div key={o.value} style={{ width: '25%', textAlign: 'center', fontWeight: 'bold' }}>
                                              {o.value} <br /> {o.label}</div>)}
                                      </div>
                                    </th>
                                  </tr>


                                  {category.questions
                                    .filter(q => q.grade_level == currentStudent.grade_level)
                                    .map(q => <tr key={q.id}>
                                        <td>{q.title}</td>
                                        <td>


                                          {<SelectField
                                            valueSelector='importance'
                                            fieldProps={{
                                              label: t('common.importance'),
                                              name: `answers[${q.id}]`,
                                            }}
                                            apiCall={plopImportanceSelectData}
                                          />}

                                        </td>
                                        <td className='radio-vertical'>
                                            <RadioField
                                              valueSelector='points'
                                              fieldProps={{
                                                label: '',
                                                name: `answers[${q.id}]`,
                                              }}
                                              options={options.filter(o => o.value != "0").map(o => {
                                                return {value: o.value, label: ''}
                                              })}
                                              onChange={(newValue) => {
                                              }}
                                            />
                                        </td>
                                    </tr>)}

                                  </tbody>
                                </table> 
                              </div> 
                          )) 
                        }  
                    </div> 
                  </div>
                  }
              </Grid>    

              <Grid item xs={12}>

             
                <div style={{display:'flex', width: '100%'}}>
                  <div>   
                    {activeStep > 0 &&
                    <Button
                      variant='outlined'
                      color='black'
                      onClick={() => setActiveStep(activeStep-1)}
                      sx={{ minHeight: '2.5rem', width: '7rem' }}
                    >
                      <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                      {`${t('common.back')}`}
                    </Button>
                    }
                  </div> 
                  <div style={{marginLeft: 'auto'}}>   
                    {activeStep+1 < plopQuestionCategories.list.length &&
                    <Button
                      size='small'
                      variant='contained'
                      color='primary'
                      onClick={() => {
                          setActiveStep(activeStep+1)
                      }}
                      sx={{ minHeight: '2.5rem', width: '7rem' }}
                    >
                      {`${t('common.next')}`}
                    </Button>
                    }

                    {activeStep+1 === plopQuestionCategories.list.length  && 
                          <SubmitButton
                              color={crudColorMap[action]}
                              text={`${t('form-actions.' + action)}`}
                              icon={crudIconMap[action]}
                              sx={{ minHeight: '2.5rem', width: '7rem' }}
                              isLoading={isLoading}
                          />
                    }

                  </div>   
                </div>    


              </Grid>
            </Grid>
          </Form>
          )
        }}
        </Formik>
    }
    </>
  )
}
export default PlopReportForm
